import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { useModal } from "../context/ModalContext";
import { productsData } from "../data/languageData";
import { productsList } from "../data/productsData";

const Products = () => {
  const { translate } = useLanguage();
  const { openModal } = useModal();

  const handleProductClick = (productId) => {
    openModal("product", productsData[productId]);
  };

  // Fallback untuk background image yang lebih baik
  const handleBgImageError = (e) => {
    const container = e.target;
    container.style.background =
      "linear-gradient(135deg, var(--primary-blue), var(--accent-teal))";

    // Update icon agar terlihat kontras
    const icon = container.querySelector(".product-icon");
    if (icon) {
      icon.style.background = "rgba(255, 255, 255, 0.9)";
      const iconElement = icon.querySelector("i");
      if (iconElement) {
        iconElement.style.color = "var(--primary-blue)";
      }
    }
  };

  return (
    <section className="products" id="products">
      <div className="container">
        <div className="section-title">
          <h2>{translate("products-title")}</h2>
          <p>{translate("products-desc")}</p>
        </div>

        <div className="products-grid">
          {productsList.map((product) => (
            <div
              className="product-card"
              key={product.id}
              data-product={product.id}
              onClick={() => handleProductClick(product.id)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  handleProductClick(product.id);
                }
              }}
            >
              <div
                className="product-image"
                style={{
                  backgroundImage: `url(${product.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  position: "relative",
                }}
                onError={handleBgImageError}
              >
                {/* Fallback background jika image gagal load */}
                <div
                  className="product-image-fallback"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background:
                      "linear-gradient(135deg, var(--primary-blue), var(--accent-teal))",
                    opacity: 0,
                    transition: "opacity 0.3s",
                    zIndex: 1,
                  }}
                ></div>
                <div className="product-icon">
                  <i className={product.icon}></i>
                </div>
              </div>
              <div className="product-content">
                <span className="product-tag">{translate("saas-tag")}</span>
                <h3>{translate(product.titleKey)}</h3>
                <p>{translate(product.descKey)}</p>
                <button
                  className="product-link"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleProductClick(product.id);
                  }}
                  style={{
                    background: "none",
                    border: "none",
                    padding: 0,
                    cursor: "pointer",
                    color: "var(--primary-blue)",
                    fontWeight: "600",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    fontSize: "0.95rem",
                    textDecoration: "none",
                  }}
                >
                  <span>{translate("view-details")}</span>{" "}
                  <i className="fas fa-arrow-right"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
